import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import {
  PollResult,
  ToolExecuteParams,
  ToolResult,
} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {poll} from 'common/src/modules/shared/copilot/utils/poll';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {CampaignsAgentsToolsNames} from '../copilotCampaigns.enums';

const inputSchema = z.object({});

function navigateToCampaignsLibraryTool(store: CLStore) {
  function _isCampaignsLibraryDataReady(): PollResult {
    if (
      store.getState().application.breadcrumbs.includes(BreadcrumbName.CampaignsLibrary) &&
      store.getState().campaignsLibrary.campaigns.length
    ) {
      return {passed: true};
    }

    return {passed: false, reason: 'Campaigns library failed to load'};
  }

  async function execute({}: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    routingService.goTo({
      url: Routes.Campaigns,
    });

    const result = await poll({checkFn: _isCampaignsLibraryDataReady});

    return toolResult(result.passed ? `Navigated to campaigns library` : result.reason);
  }

  return tool({
    name: CampaignsAgentsToolsNames.NavigateToCampaignsLibrary,
    description: 'Navigate to campaigns library',
    displayName: 'Navigating',
    execute,
    inputSchema,
  });
}

export default navigateToCampaignsLibraryTool;
